"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStoreReference = void 0;
const index_1 = require("../Base/index");
/**
 * Contains a reference to a DataStore.
 *
 * NOT SUPPORTED YET.
 */
class DataStoreReference extends index_1.BaseElement {
}
exports.DataStoreReference = DataStoreReference;
//# sourceMappingURL=DataStoreReference.js.map